export default {"src":"/_next/static/media/400_error.76d8acee.svg","height":150,"width":255,"blurWidth":0,"blurHeight":0};